(ns com.theplantscape.plant-web.pages.plant-layouts
  (:require
   [com.theplantscape.plant-web.api.plants :refer [fetch-plant]]
   [com.theplantscape.plant-web.components.history :refer [ui-history]]
   [com.theplantscape.plant-web.components.search :refer [ui-plant-search]]
   [com.theplantscape.plant-web.components.tiles :refer [plant-tile]]
   [com.theplantscape.plant-web.draw.state :refer [app-state]]
   [reagent.core :as r]
   [reitit.frontend.easy :as rfe]))

;(rfe/push-state :plant {:plant-id "21f72dad-ae62-4738-a2ad-0ce737b51135"})

(defn change-page [{:keys [id plant-id revision] :as p}]
  (rfe/push-state :plant {:plant-id id}))

(defn change-plant [{:keys [id revision] :as p}]
  (fetch-plant (or (-> p :plant-id) (-> p :id) ) revision
               (fn [plant]
                 (if (= (-> @app-state :plant :plant :xt/id) (:xt/id plant))
                   (swap! app-state assoc-in [:plant :plant] (:plant plant))
                   (swap! app-state assoc :plant plant))
                 #_(reset! store plant))))

(defn ui-page-plant  [_]
  (let [current-plant (r/cursor app-state [:plant]) ]
    [:div.w-full
     [:a {:on-click #(reset! current-plant nil) :href (rfe/href :plant-search)} "Search"]
     (if (-> @current-plant empty?)
       [ui-plant-search change-page]
       [:div
        [:div (:decription @current-plant)]
        [:div.flex.items-start
         [plant-tile (:plant @current-plant)]
         [ui-history (-> @current-plant :plant :xt/id) (:history @current-plant)]]
        #_(str @current-plant)])]))

(comment
  (change-plant {:plant-id "string" :revision 4}))
